// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pairstats-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    background-color: var(--bg-app);
}

/* ── Hero ── */
.pairstats-hero {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);
    color: white;
    padding: 20px 20px 60px;
    position: relative;
    overflow: hidden;
    box-shadow: var(--shadow-card);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.pairstats-hero::before {
    content: '';
    position: absolute;
    top: -40%;
    left: -5%;
    width: 280px;
    height: 280px;
    background: rgba(255, 255, 255, 0.04);
    border-radius: 50%;
    pointer-events: none;
}

.pairstats-hero::after {
    content: '';
    position: absolute;
    bottom: -30%;
    right: -5%;
    width: 220px;
    height: 220px;
    background: rgba(210, 248, 0, 0.06);
    border-radius: 50%;
    pointer-events: none;
}

.pairstats-hero-top {
    width: 100%;
    max-width: 900px;
    position: relative;
    z-index: 2;
}

.pairstats-hero-inner {
    position: relative;
    z-index: 2;
    max-width: 900px;
    width: 100%;
    text-align: center;
    margin-top: 20px;
}

.pairstats-eyebrow {
    display: inline-block;
    background: rgba(255, 255, 255, 0.15);
    color: var(--brand-accent, #D2F800);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 12px;
}

.pairstats-title {
    font-size: clamp(1.6rem, 4vw, 2.2rem);
    font-weight: 800;
    margin: 0 0 8px;
    color: white;
}

.pairstats-sub {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

/* ── Content ── */
.pairstats-content {
    max-width: 900px;
    margin: 0 auto;
    padding: 32px 20px 60px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.section-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--text-primary, #1e293b);
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.collapsible-header + .streak-list,
.collapsible-header + .pairs-list,
.collapsible-header + div {
    margin-top: 16px;
}

.section-title i {
    color: var(--brand-primary);
}

/* ── Top 3 ── */
.top-section .collapsible-header,
.top-section .section-title {
    margin-bottom: 20px;
}

.top-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
}

.top-card {
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-light);
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
    transition: transform 0.2s;
}

.top-card:hover {
    transform: translateY(-3px);
}

.top-card--1 {
    border-top: 3px solid #f59e0b;
}

.top-card--2 {
    border-top: 3px solid #94a3b8;
}

.top-card--3 {
    border-top: 3px solid #b45309;
}

.top-medal {
    font-size: 1.8rem;
}

.top-avatars {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 4px 0;
}

.top-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--brand-primary);
    color: white;
    font-size: 0.8rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.top-avatar--b {
    background: #1e293b;
    color: white;
}

.top-plus {
    font-size: 1.1rem;
    color: var(--text-muted);
    font-weight: 700;
}

.top-names {
    display: flex;
    flex-direction: column;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--text-primary, #1e293b);
    gap: 2px;
}

.top-pct {
    font-size: 1.8rem;
    font-weight: 800;
    color: var(--brand-primary);
}

.top-detail {
    font-size: 0.78rem;
    color: var(--text-muted);
}

/* ── Collapsible headers ── */
.collapsible-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    text-align: left;
    cursor: pointer;
    gap: 12px;
    margin-bottom: 0;
}

.collapsible-chevron {
    font-size: 0.9rem;
    color: var(--text-secondary, #64748b);
    transition: transform 0.25s ease;
    flex-shrink: 0;
}

.collapsible-chevron--open {
    transform: rotate(180deg);
}

.list-header-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* ── List controls ── */
.list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 0;
}

.list-controls {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.list-controls select {
    border: 1px solid var(--border-light);
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 0.85rem;
    background: var(--bg-card);
    color: var(--text-primary, #1e293b);
    cursor: pointer;
}

/* ── Pair cards ── */
.pairs-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
}

.pair-card {
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    border: 1px solid var(--border-light);
    padding: 18px 20px;
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 16px;
    transition: box-shadow 0.2s;
}

.pair-card:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.pair-players {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.pair-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: var(--brand-primary);
    color: white;
    font-size: 0.78rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pair-avatar--b {
    background: #1e293b;
    color: white;
}

.pair-names {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.pair-names span {
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--text-primary, #1e293b);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Stats ── */
.pair-data {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;
}

.pair-counters {
    display: flex;
    gap: 16px;
}

.pair-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.counter-val {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--text-primary, #1e293b);
    line-height: 1;
}

.pair-counter--win .counter-val  { color: #16a34a; }
.pair-counter--loss .counter-val { color: #dc2626; }

.counter-lbl {
    font-size: 0.7rem;
    color: var(--text-muted);
    white-space: nowrap;
}

.winrate-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.winrate-bar {
    width: 90px;
    height: 6px;
    background: var(--border-light, #e2e8f0);
    border-radius: 99px;
    overflow: hidden;
}

.winrate-fill {
    height: 100%;
    border-radius: 99px;
    transition: width 0.4s ease;
}

.winrate-fill.rating--good { background: #16a34a; }
.winrate-fill.rating--mid  { background: #f59e0b; }
.winrate-fill.rating--low  { background: #dc2626; }
.winrate-fill.rating--none { background: #94a3b8; }

.winrate-pct {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--text-primary, #1e293b);
    min-width: 36px;
    text-align: right;
}

.pair-no-history {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--text-muted);
    font-size: 0.85rem;
}

/* ── Rating badge ── */
.pair-rating {
    font-size: 0.75rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
    white-space: nowrap;
}

.pair-rating.rating--good { background: #dcfce7; color: #16a34a; }
.pair-rating.rating--mid  { background: #fef3c7; color: #b45309; }
.pair-rating.rating--low  { background: #fee2e2; color: #dc2626; }
.pair-rating.rating--none { background: #f1f5f9; color: #64748b; }

/* ── States ── */
.pairstats-loading,
.pairstats-empty,
.pairstats-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 60px 20px;
    color: var(--text-muted);
    text-align: center;
}

.pairstats-error {
    color: #dc2626;
}

/* ── Responsive ── */
@media (max-width: 640px) {
    .pair-card {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .pair-data {
        align-items: flex-start;
    }

    .pair-counters {
        gap: 20px;
    }

    .top-grid {
        grid-template-columns: 1fr;
    }

    .list-header {
        flex-direction: column;
        align-items: flex-start;
    }
}

/* ── Streak section ── */
.streak-section {
    margin-bottom: 40px;
}

.streak-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 16px;
}

.streak-card {
    display: flex;
    align-items: center;
    gap: 14px;
    background: var(--bg-card, #fff);
    border-radius: 12px;
    padding: 14px 18px;
    box-shadow: var(--shadow-card);
    border-left: 4px solid transparent;
    transition: transform 0.15s ease;
}

.streak-card:hover {
    transform: translateX(3px);
}

.streak-card--win {
    border-left-color: #22c55e;
}

.streak-card--loss {
    border-left-color: #ef4444;
}

.streak-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--brand-primary);
    color: white;
    font-size: 0.78rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.streak-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.streak-name {
    font-weight: 600;
    font-size: 0.95rem;
    color: var(--text-primary, #0F172A);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.streak-label {
    font-size: 0.82rem;
    color: var(--text-secondary, #64748b);
}

.streak-badge {
    font-size: 1.1rem;
    font-weight: 800;
    min-width: 36px;
    text-align: center;
    flex-shrink: 0;
}

.streak-badge--win {
    color: #22c55e;
}

.streak-badge--loss {
    color: #ef4444;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PairStats.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA,eAAe;AACf;IACI,0EAA0E;IAC1E,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;IACnC,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,gBAAgB;AAChB;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,mCAAmC;IACnC,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;IAC9B,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;AAClB;;AAEA,mCAAmC,cAAc,EAAE;AACnD,mCAAmC,cAAc,EAAE;;AAEnD;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;AAClD,6BAA6B,mBAAmB,EAAE;;AAElD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE,iBAAiB;AACjB;;;IAGI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".pairstats-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 70px);\n    background-color: var(--bg-app);\n}\n\n/* ── Hero ── */\n.pairstats-hero {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);\n    color: white;\n    padding: 20px 20px 60px;\n    position: relative;\n    overflow: hidden;\n    box-shadow: var(--shadow-card);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.pairstats-hero::before {\n    content: '';\n    position: absolute;\n    top: -40%;\n    left: -5%;\n    width: 280px;\n    height: 280px;\n    background: rgba(255, 255, 255, 0.04);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.pairstats-hero::after {\n    content: '';\n    position: absolute;\n    bottom: -30%;\n    right: -5%;\n    width: 220px;\n    height: 220px;\n    background: rgba(210, 248, 0, 0.06);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.pairstats-hero-top {\n    width: 100%;\n    max-width: 900px;\n    position: relative;\n    z-index: 2;\n}\n\n.pairstats-hero-inner {\n    position: relative;\n    z-index: 2;\n    max-width: 900px;\n    width: 100%;\n    text-align: center;\n    margin-top: 20px;\n}\n\n.pairstats-eyebrow {\n    display: inline-block;\n    background: rgba(255, 255, 255, 0.15);\n    color: var(--brand-accent, #D2F800);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    padding: 4px 12px;\n    border-radius: 20px;\n    margin-bottom: 12px;\n}\n\n.pairstats-title {\n    font-size: clamp(1.6rem, 4vw, 2.2rem);\n    font-weight: 800;\n    margin: 0 0 8px;\n    color: white;\n}\n\n.pairstats-sub {\n    font-size: 1rem;\n    color: rgba(255, 255, 255, 0.7);\n    margin: 0;\n}\n\n/* ── Content ── */\n.pairstats-content {\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 32px 20px 60px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.section-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--text-primary, #1e293b);\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.collapsible-header + .streak-list,\n.collapsible-header + .pairs-list,\n.collapsible-header + div {\n    margin-top: 16px;\n}\n\n.section-title i {\n    color: var(--brand-primary);\n}\n\n/* ── Top 3 ── */\n.top-section .collapsible-header,\n.top-section .section-title {\n    margin-bottom: 20px;\n}\n\n.top-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n}\n\n.top-card {\n    background: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-light);\n    padding: 24px 16px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    text-align: center;\n    transition: transform 0.2s;\n}\n\n.top-card:hover {\n    transform: translateY(-3px);\n}\n\n.top-card--1 {\n    border-top: 3px solid #f59e0b;\n}\n\n.top-card--2 {\n    border-top: 3px solid #94a3b8;\n}\n\n.top-card--3 {\n    border-top: 3px solid #b45309;\n}\n\n.top-medal {\n    font-size: 1.8rem;\n}\n\n.top-avatars {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin: 4px 0;\n}\n\n.top-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: var(--brand-primary);\n    color: white;\n    font-size: 0.8rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.top-avatar--b {\n    background: #1e293b;\n    color: white;\n}\n\n.top-plus {\n    font-size: 1.1rem;\n    color: var(--text-muted);\n    font-weight: 700;\n}\n\n.top-names {\n    display: flex;\n    flex-direction: column;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: var(--text-primary, #1e293b);\n    gap: 2px;\n}\n\n.top-pct {\n    font-size: 1.8rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n}\n\n.top-detail {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n}\n\n/* ── Collapsible headers ── */\n.collapsible-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    background: none;\n    border: none;\n    padding: 0;\n    text-align: left;\n    cursor: pointer;\n    gap: 12px;\n    margin-bottom: 0;\n}\n\n.collapsible-chevron {\n    font-size: 0.9rem;\n    color: var(--text-secondary, #64748b);\n    transition: transform 0.25s ease;\n    flex-shrink: 0;\n}\n\n.collapsible-chevron--open {\n    transform: rotate(180deg);\n}\n\n.list-header-right {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* ── List controls ── */\n.list-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 0;\n}\n\n.list-controls {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.list-controls select {\n    border: 1px solid var(--border-light);\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 0.85rem;\n    background: var(--bg-card);\n    color: var(--text-primary, #1e293b);\n    cursor: pointer;\n}\n\n/* ── Pair cards ── */\n.pairs-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 16px;\n}\n\n.pair-card {\n    background: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    border: 1px solid var(--border-light);\n    padding: 18px 20px;\n    display: grid;\n    grid-template-columns: 1fr auto auto;\n    align-items: center;\n    gap: 16px;\n    transition: box-shadow 0.2s;\n}\n\n.pair-card:hover {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.pair-players {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n}\n\n.pair-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: var(--brand-primary);\n    color: white;\n    font-size: 0.78rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.pair-avatar--b {\n    background: #1e293b;\n    color: white;\n}\n\n.pair-names {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.pair-names span {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: var(--text-primary, #1e293b);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Stats ── */\n.pair-data {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-end;\n}\n\n.pair-counters {\n    display: flex;\n    gap: 16px;\n}\n\n.pair-counter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n}\n\n.counter-val {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--text-primary, #1e293b);\n    line-height: 1;\n}\n\n.pair-counter--win .counter-val  { color: #16a34a; }\n.pair-counter--loss .counter-val { color: #dc2626; }\n\n.counter-lbl {\n    font-size: 0.7rem;\n    color: var(--text-muted);\n    white-space: nowrap;\n}\n\n.winrate-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.winrate-bar {\n    width: 90px;\n    height: 6px;\n    background: var(--border-light, #e2e8f0);\n    border-radius: 99px;\n    overflow: hidden;\n}\n\n.winrate-fill {\n    height: 100%;\n    border-radius: 99px;\n    transition: width 0.4s ease;\n}\n\n.winrate-fill.rating--good { background: #16a34a; }\n.winrate-fill.rating--mid  { background: #f59e0b; }\n.winrate-fill.rating--low  { background: #dc2626; }\n.winrate-fill.rating--none { background: #94a3b8; }\n\n.winrate-pct {\n    font-size: 0.85rem;\n    font-weight: 700;\n    color: var(--text-primary, #1e293b);\n    min-width: 36px;\n    text-align: right;\n}\n\n.pair-no-history {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--text-muted);\n    font-size: 0.85rem;\n}\n\n/* ── Rating badge ── */\n.pair-rating {\n    font-size: 0.75rem;\n    font-weight: 700;\n    padding: 4px 10px;\n    border-radius: 20px;\n    white-space: nowrap;\n}\n\n.pair-rating.rating--good { background: #dcfce7; color: #16a34a; }\n.pair-rating.rating--mid  { background: #fef3c7; color: #b45309; }\n.pair-rating.rating--low  { background: #fee2e2; color: #dc2626; }\n.pair-rating.rating--none { background: #f1f5f9; color: #64748b; }\n\n/* ── States ── */\n.pairstats-loading,\n.pairstats-empty,\n.pairstats-error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 60px 20px;\n    color: var(--text-muted);\n    text-align: center;\n}\n\n.pairstats-error {\n    color: #dc2626;\n}\n\n/* ── Responsive ── */\n@media (max-width: 640px) {\n    .pair-card {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n\n    .pair-data {\n        align-items: flex-start;\n    }\n\n    .pair-counters {\n        gap: 20px;\n    }\n\n    .top-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .list-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n/* ── Streak section ── */\n.streak-section {\n    margin-bottom: 40px;\n}\n\n.streak-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 16px;\n}\n\n.streak-card {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    background: var(--bg-card, #fff);\n    border-radius: 12px;\n    padding: 14px 18px;\n    box-shadow: var(--shadow-card);\n    border-left: 4px solid transparent;\n    transition: transform 0.15s ease;\n}\n\n.streak-card:hover {\n    transform: translateX(3px);\n}\n\n.streak-card--win {\n    border-left-color: #22c55e;\n}\n\n.streak-card--loss {\n    border-left-color: #ef4444;\n}\n\n.streak-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: var(--brand-primary);\n    color: white;\n    font-size: 0.78rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.streak-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.streak-name {\n    font-weight: 600;\n    font-size: 0.95rem;\n    color: var(--text-primary, #0F172A);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.streak-label {\n    font-size: 0.82rem;\n    color: var(--text-secondary, #64748b);\n}\n\n.streak-badge {\n    font-size: 1.1rem;\n    font-weight: 800;\n    min-width: 36px;\n    text-align: center;\n    flex-shrink: 0;\n}\n\n.streak-badge--win {\n    color: #22c55e;\n}\n\n.streak-badge--loss {\n    color: #ef4444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
